import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-back\"><defs><style type=\"text/css\"></style></defs><path d=\"M332.8 307.2v204.8L25.6 256l307.2-256v204.8h256a409.6 409.6 0 1 1 0 819.2H128v-102.4h460.8a307.2 307.2 0 1 0 0-614.4H332.8z\" p-id=\"8943\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol